import React from "react";
import { Box, Label, CheckBox, NullCommand, ErrorExclamationView, theme } from "Application";
import { TableBox } from "./SessionReport.styles";
import { IStudentSessionReportViewModel } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";
import { observer } from "mobx-react-lite";

export const SessionReportInvolvement: React.FC<{ viewModel: IStudentSessionReportViewModel }> = observer(({ viewModel }) => (
    <Box flexBox flexDirection={"column"} gap="20px">
        <Box>
            <Box display="flex">
                <Label fontStyle="h2">Involvement*</Label>
                <ErrorExclamationView haveError={viewModel.showInvolvementError} validationMessage={() => viewModel.getError("involvementId")} />
            </Box>
            <Label fontStyle="field">
                Involvement focuses on the extent to which pupils are operating to their full capabilities. In particular it refers to whether the young person is focused, engaged
                and interest in various activities.
            </Label>
        </Box>

        <Box bg={theme.palette.common.lightGrey} border="1px solid #D4D4D4">
            <Box flexBox flexDirection={"column"} gap="10px">
                <div>
                    {viewModel.model.wellbeing.map((item, index) => (
                        <TableBox color={item.displayColor} key={item.KEY}>
                            <CheckBox
                                key={index}
                                command={new NullCommand()}
                                onChange={() => viewModel.updateInvolvementCommand.execute(item.id)}
                                displayName={item.severityLevel}
                                value={() => viewModel.model.involvementId === item.id}
                            />
                            <Box>
                                <Label style={{ color: `${item.displayColor}` }}>{item.severityLevel}</Label>
                                <Label>{item.involvementDescription}</Label>
                            </Box>
                        </TableBox>
                    ))}
                </div>
            </Box>
        </Box>
    </Box>
));
